module.exports = __webpack_public_path__ + "img/scene_ocean_backlight@2x.1133a5c5.png";